import {
    TrendingUpOutlined,
    MemoryOutlined,
    ExtensionOutlined
} from '@mui/icons-material';

const Benefits = [
    {
        icon: <TrendingUpOutlined />,
        title: 'Market-leading Results',
        description: 'Backtested to outperform every major fund and stock advisor. Keep more of your gains with our competitive pricing.</div>'
    },
    {
        icon: <MemoryOutlined />,
        title: 'Advanced Automation',
        description: 'Combining technical, fundamental, and AI-driven sentiment analysis for comprehensive market insights. All data collection, sanitization and stock selections are fully automated, eliminating psychological bias and improving performance.'
    },
    {
        icon: <ExtensionOutlined />,
        title: 'Flexible Runtime',
        description: 'Execute our portfolios on any brokerage platform using our API, unlike restricted ETFs and mutual funds. Take advantage of tax efficient investment accounts to maximize your wealth. Extend with your own custom scripts.'
    }
];

export default Benefits;